import { AssignationsType } from 'routes/Task/enums';

export const selectAreaModal = `select-${AssignationsType.Area}`;
export const selectAssetModal = `select-${AssignationsType.Equipment}`;
export const unselectAreaModal = `unselect-${AssignationsType.Area}`;
export const unselectAssetModal = `unselect-${AssignationsType.Equipment}`;
export const modals = [
  selectAreaModal,
  selectAssetModal,
  unselectAreaModal,
  unselectAssetModal,
];
